module.exports = __webpack_public_path__ + "img/fond_accueil.e03e8738.jpg";